import { ApiClient } from '@webapp/core/services/ApiClient'
import { PODisclaimerRepository } from './PODisclaimerRepository'

export const poDisclaimerRepository = new PODisclaimerRepository({
  httpClient: ApiClient,
})

export { PODisclaimerRepository }
